import { cn } from "@d12labs/utils";
import type * as React from "react";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
	// Linear input spec: h-9, rounded-md (8px), surface-2 bg, no visible border at rest
	// (the surface lift IS the boundary — works against canvas and against surface-1 cards),
	// hairline ring on focus.
	return (
		<input
			type={type}
			data-slot="input"
			className={cn(
				"file:text-foreground placeholder:text-ink-subtle selection:bg-primary selection:text-primary-foreground h-9 w-full min-w-0 rounded-md bg-input text-foreground px-3 py-2 text-body leading-none transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
				"focus-visible:ring-2 focus-visible:ring-ring/50",
				"aria-invalid:ring-2 aria-invalid:ring-destructive/40",
				className,
			)}
			{...props}
		/>
	);
}

export { Input };
